<template>
    <div class="full-screen" >
        <div  v-click-outside="outsidePopup"  class="popup-window"  v-if="contentType == 'slider'">
            <a class="close" @click="popup()">X</a>
            <div v-if="allItemsLoaded" class="slider-container"> 
                <Slider 
                class="slider" 
                :items="items"/>
            </div>
        </div>
    </div>
</template>

<script>
import Slider from './builder/Slider.vue'
import {mapGetters} from 'vuex'
import ClickOutside from 'vue-click-outside'
export default {
    name: 'Popup',
    props: ['contentType', 'items'],
    components: {
        Slider,
    },
    data() {
        return {
            mounted: false,
        }
    },
    methods: {
        popup(){
            this.$parent.popup()
        },
        outsidePopup(){
            if(this.mounted == true && this.popupSwitch == true){
                this.popup()
            }
            return 
        }
    },
    computed: {
        ...mapGetters([
            'allItemsLoaded',
        ]),
        popupSwitch: function() {
            return this.$parent.popupSwitch
        }
    },
    directives: {
        ClickOutside
    },
    mounted(){
        setTimeout(() => {
             this.mounted = true
        }, 1000);
    }
}
</script>

<style scoped>
.full-screen {
    z-index: 999;
    left: 0px;
    top: 0px;
    right: 0px;
    min-width: 930px !important;
    position: fixed;
    bottom: 0px;
}
.popup-window {
    overflow-y: hidden;
    overflow-x: hidden;
    min-width: 930px !important;
    position: fixed;
    left: 15%;
    top: 15%;
    right: 15%;
    max-width: 1350px;
    border: 1px solid #434857;
    border-radius: 6px;
    padding: 40px;
    bottom: 15%;
    box-shadow: 0px 0px 150px 179px #191b20;
    background-color: #191b20;
}
@media screen and (max-width: 1400px) {
    .popup-window {
        top: 5%;
        bottom: 5%;
        left: 5%;
        right: 5%;
    }
}
@media screen and (max-width: 1160px) {
    .popup-window {
        left: 1%;
        right: 1%;
        top: 1%;
        bottom: 1%;
        padding-left: 0px;
        padding-right: 0px;
    }
}
.close {
    position: absolute;
    right: 2%;
    top: 2%;
}
</style>